import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import { Link } from 'react-router-dom';
import { Route } from 'react-router-dom';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListingLoader from '../Common/skeletonLoaders/listingLoader'
import { showSnackBar } from '../../store/AlertMessages/actionCreator';
import { ERROR_FETCHING_ASSIGNMENT, ERROR_FETCHING_ASSIGNMENT_REPORT } from '../Common/Constants/errorMessages';
import TabView from './tabView'
import { convertUTCTimeZone } from '../../Helpers/basic'
import { fetchExternalAssignmentData, fetchExternalAssignmentReport, fetchExternalAssRptTabCount } from '../../store/Assignments/actionCreator'


const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper
  },
  topButtonNav: {
    backgroundColor: '#f5f5f5',
    textAlign: 'left'
  },
  button: {
    textTransform: 'none',
    flexGrow: 1,
    marginTop: '10px'
  },
  breadCrumbcontainer: {
    padding: '15px',
    marginLeft: '10px',
    justifyContent: "center",
    marginTop: '-19px'
  }, 
  textWrapper: {
    fontWeight: 500,
    color: '#2e8eec',
    fontSize: '19px',
    textAlign: 'center'
  },
  dueDateWrapper: {
    color: '#2e8eec',
    textAlign: 'center',
    marginTop: '-2px',
    fontSize: '16px',
    marginBottom: '13px',
    fontWeight: 500
  },
}))

function AssessmentReport(props) {
  const classes = useStyles();
  const mediaWidth = useMediaQuery('(min-width:700px)')
  let rowsPerPage = 10
  let offset = 0
  const [page, setPage] = React.useState(0)
  const [paginationLoader, setPaginationLoader] = React.useState(false)
  const [hidePagination, setHidePagination] = React.useState(false)
  const [inProgress, setInprogress] = React.useState(false)
  const [selectedTab, setSelectedTab] = React.useState(0)
  const [assessmentDetails, setAssessmentDetails] = React.useState({})
  const [assessmentReport, setAssessmentReport] = React.useState([])
  const [totalCount, setTotalCount] = React.useState(0)
  const [tabCount, setTabCount] = React.useState({
    yet_to_start: 0,
    inProgress: 0,
    completed: 0
  })

  const assessmentSuccessCB = res => {
    setAssessmentDetails(res && res.data && res.data)
  }
  const assessmentFailureCB = error => {
    setAssessmentDetails({})
    props.showSnackBar(
        {
          state: false,
          message: ERROR_FETCHING_ASSIGNMENT,
          type: 'error'
        }
    )
  }

  //Report call backs
  const successReportFetch = res => {
    setAssessmentReport(res && res.data && res.data)
    setTotalCount(res && res.count)
    setPaginationLoader(false)
    setHidePagination(false)
    setInprogress(false)
  }
  const failureReportFetch = error => {
    setAssessmentReport([])
    setTotalCount(0)
    setPaginationLoader(false)
    setHidePagination(false)
    setInprogress(false)
    props.showSnackBar(
      {
        state: false,
        message: ERROR_FETCHING_ASSIGNMENT_REPORT,
        type: 'error'
      }
    )
  }

  const getReport = () => {
    setPaginationLoader(true)
    setHidePagination(true)
    setInprogress(true)
    const payload = {
      assignment_id: props.match.params.assignmentId,
      status: 1,
      offset: offset,
      number: 10
    }
    fetchExternalAssignmentReport(payload, successReportFetch, failureReportFetch)
  }

  const assessmentTabSuccess = res => {
    setTabCount({
      yet_to_start: res && res.data && res.data[1],
      inProgress: res && res.data && res.data[2],
      completed: res && res.data && res.data[3]
    })
  }

  const assessmentTabFailure = error => {
    props.showSnackBar(
      {
        state: false,
        message: ERROR_FETCHING_ASSIGNMENT_REPORT,
        type: 'error'
      }
    )
  }

  useEffect(() => {
    const payload = {
      assignment_id: props.match.params.assignmentId
    }
    fetchExternalAssignmentData(payload, assessmentSuccessCB, assessmentFailureCB)
    fetchExternalAssRptTabCount(payload, assessmentTabSuccess, assessmentTabFailure)
    getReport()
  },[])

  const getBreadCrumbs = () => {
    return(
      <Route>
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
          <Link style={{ textDecoration: 'none'}} color="inherit" to="/mycourse">
            Home
          </Link>
          <Link style={{ textDecoration: 'none'}} color="inherit" to="/externalassignments">
            {assessmentDetails && assessmentDetails.title}
          </Link>
          <Typography color="textPrimary">Assignment Report</Typography>
        </Breadcrumbs>
      </Route>
    )
  }

  const onTabChange = tabKey => {
    setPage(0)
    setAssessmentReport([])
    setPaginationLoader(true)
    setHidePagination(true)
    setSelectedTab(tabKey)
    const payload = {
      assignment_id: props.match.params.assignmentId,
      status: tabKey === 0 ? 1 : tabKey === 1 ? 2 : 3,
      offset: 0,
      number: 10
    }
    fetchExternalAssignmentReport(payload, successReportFetch, failureReportFetch)
  }

  const onPagination = (pageNum) => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    setPage(pageNum)
    let offset = pageNum * rowsPerPage
    let number = 10
    setPaginationLoader(true)
    setHidePagination(true)
    const payload = {
      assignment_id: props.match.params.assignmentId,
      status: selectedTab === 0 ? 1 : selectedTab === 1 ? 2 : 3,
      offset: offset,
      number: number
    }
    fetchExternalAssignmentReport(payload, successReportFetch, failureReportFetch)
  }

  const listLoader = count => {
    let children = []
    for (let i = 0; i < 3; i++) {
     children.push(<ListItem key={i} alignItems="flex-start"><ListingLoader/></ListItem>)
    }
    return (
      <List>
        {children}
      </List>
    )
   }

   const dateFormat = (due_days) => {
    return(`Due Date: ${convertUTCTimeZone(due_days)}`)
  }

  return(
    <div className={classes.root}>
      <div id="mainH1Tag" tabIndex="-1" className="accessibility">
        <h1>Assignment report page</h1>
      </div>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Paper elevation={0} className={classes.topButtonNav}>
            <div className={classes.breadCrumbcontainer}>
              {getBreadCrumbs()}
            </div>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ marginTop: '20px', paddingLeft: !mediaWidth ? '10px' : '200px', paddingRight: !mediaWidth ? '10px' : '200px' }}>  
          { inProgress ? (
            listLoader()
          ) :(
            <React.Fragment>
              <Typography className={classes.textWrapper}>{ assessmentDetails && assessmentDetails.title ? assessmentDetails.title : '' }</Typography>
              <Typography className={classes.dueDateWrapper}>{dateFormat(assessmentDetails && assessmentDetails.end_date )} | {assessmentDetails && assessmentDetails.points ? `Points: ${assessmentDetails.points}` : null }</Typography>
              <TabView
                histoy={props.history}
                match={props.match}
                onTabChange={onTabChange}
                onPagination={onPagination}
                paginationLoader={paginationLoader} 
                page={page}
                rowsPerPage={rowsPerPage}
                totalCount={totalCount}
                assessmentReportData={assessmentReport}
                hidePagination={hidePagination}
                tabCount={tabCount}
              />
            </React.Fragment>
          )}
        </Grid>
      </Grid>
    </div>
  )
}

const mapStateToProps = state => {
  return {}
}
export default connect(
  mapStateToProps, { showSnackBar }
)(AssessmentReport);